import React from 'react';

const defaultOptions: IntersectionObserverInit = {
    rootMargin: '0px',
    threshold: 0.01
};

export function useIntersectionObserver(options: IntersectionObserverInit = defaultOptions) {
    const [isVisible, setIsVisible] = React.useState(false);
    const elementRef = React.useRef<HTMLElement | null>(null);
    const observerRef = React.useRef<IntersectionObserver | null>(null);

    React.useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                setIsVisible(entry.isIntersecting);
            });
        }, options);

        observerRef.current = observer;

        if (elementRef.current) {
            observer.observe(elementRef.current);
        }

        return () => {
            if (observerRef.current) {
                observerRef.current.disconnect();
            }
        };
    }, [options]);

    const setRef = React.useCallback((element: HTMLElement | null) => {
        if (elementRef.current && observerRef.current) {
            observerRef.current.unobserve(elementRef.current);
        }

        elementRef.current = element;

        if (element && observerRef.current) {
            observerRef.current.observe(element);
        }
    }, []);

    return { isVisible, setRef };
}
